export default ({ request }) => ({
  ecomAmzApiReportTaskRecordListApi(data = {}) {
    return request({
      url: '/ecomorder/amz/api/report/task/record/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzApiReportTaskRecordDetailApi(data = {}) {
    return request({
      url: '/ecomorder/amz/api/report/task/record/detail',
      method: 'POST',
      data,
    })
  },
})
